import { Box, Flex, Text } from "@chakra-ui/react";
import { FiClock } from "react-icons/fi";
import { combinedLoadCopy } from "../../helpers/goals";

/**
 * The honest version of a limit: total daily requirement across active
 * goals, next to what the user actually reads.
 */
const CombinedLoadRow = ({ load }) => {
  const copy = combinedLoadCopy(load);
  if (!copy) {
    return null;
  }
  const warning = load.tone === "warning";

  return (
    <Flex
      align="center"
      borderBottom="1px solid"
      borderColor="gray.700"
      gap="4"
      px={{ base: 5, md: 8 }}
      py="5"
    >
      <Box color={warning ? "#FFAA00" : "gray.300"} fontSize="28px">
        <FiClock aria-hidden />
      </Box>
      <Box>
        <Text
          color={warning ? "#FFAA00" : undefined}
          fontSize="lg"
          fontWeight="bold"
        >
          {copy.headline}
        </Text>
        <Text color="gray.400" fontSize="sm">
          {copy.detail}
        </Text>
      </Box>
    </Flex>
  );
};

export default CombinedLoadRow;
